import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../utils/AuthContext";
import { generateAcademicYears } from "../utils/academicYearUtils";
import { IoCall } from "react-icons/io5";
import { MdCheckCircle } from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Import useLocation
import logo from "../Assets/kalam_kids_best_kindergarten_logo.png";
import logo1 from "../Assets/Kalam Kids Logo_newlogo.png";
import Loader from "../Loader/Loader";


const Navbar = () => {
  const { academicYear } = useContext(AuthContext);
  const location = useLocation(); // Get current location
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState("home");
  const [isHovered, setIsHovered] = useState(null);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    studentName: "",
    gender: "",
    dob: "",
    fatherName: "",
    fatherMobile: "",
    fatherEmail: "",
    motherName: "",
    motherMobile: "",
    motherEmail: "",
    plotNo: "",
    street: "",
    landmark: "",
    area: "",
    city: "",
    state: "",
    age: "",
    academicYear: academicYear || "",
  });
  const academicYears = generateAcademicYears();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const linkColors = {
    home: "#e84c24",
    about: "#177286",
    program: "#3cbb85",
    admission: "#a7982b",
    contactUs: "#11a5e4",
    enquiry: "#16bab1", // New color for enquiry link
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveLink("home");
    else if (path === "/about") setActiveLink("about");
    else if (path === "/program") setActiveLink("Classes");
    else if (path === "/admission") setActiveLink("admission");
    else if (path === "/contactus") setActiveLink("contactUs");
    else if (path === "/enquiry") setActiveLink("enquiry");
  }, [location]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "dob" && value) {
      const dob = new Date(value);
      const currentDate = new Date();
      let calculatedAge = currentDate.getFullYear() - dob.getFullYear();
      const monthDiff = currentDate.getMonth() - dob.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dob.getDate())) {
        calculatedAge--;
      }
      setFormData((prev) => ({
        ...prev,
        age: calculatedAge,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate submission
    setTimeout(() => {
      setIsSubmitting(false);
      setShowThankYou(true);
      setModalOpen(false);
      setTimeout(() => setShowThankYou(false), 3000);
    }, 2000);
  };

  return (
    <div>
      <nav className="fixed top-0 z-50 w-full">
        <div className="wave -mt-8 "></div>

        <div className="absolute -top-[70px] mx-auto px-6 py-4 flex items-center justify-between w-full">
          <div className="flex items-center ">
            <Link to="/">
              <div className="pt-2">
                <img src={logo} alt="logo" className="h-44 w-44" />
              </div>
            </Link>
    
            <div className="hidden md:flex space-x-8 ml-8">
              {["home", "about", "Classes", "contactUs"].map((link) => (
                <Link
                  key={link}
                  to={link === "home" ? "/" : `/${link.toLowerCase()}`}
                  onClick={() => handleLinkClick(link)}
                  onMouseEnter={() => setIsHovered(link)}
                  onMouseLeave={() => setIsHovered(null)}
                  className="text-md font-bold transition duration-200 relative navbar-link"
                  style={{
                    color: activeLink === link || isHovered === link ? linkColors[link] : "black",
                  }}
                >
                  {link.charAt(0).toUpperCase() + link.slice(1)}
                  <span
                    className={`absolute -top-2 left-1/2 transform -translate-x-1/2 w-2 text-[#16bab1]enter items-center -ml-1 h-2 rounded-full transition-all duration-200 ${
                      activeLink === link || isHovered === link ? "block animate-jump " : "hidden"
                    }`}
                    style={{ backgroundColor: linkColors[link] }}
                  ></span>
                </Link>
              ))}
            </div>
          </div>

          {/* Contact and Action Buttons */}
          <div className="hidden md:flex space-x-8">
            <div className="flex items-center space-x-2 text-[#1da0d7]">
              <span className="text-md">
                <IoCall />
              </span>

              <Link to="/" className="text-lg font-medium transition flex duration-200 navbar-link">
                99945 58487
              </Link>
            </div>

            <div>
              <button
                onClick={() => navigate("/enquiry")}
                className="px-4 py-2 bg-[#16bab1] sensei-text text-white rounded-md shadow-lg"
              >
                Enquiry
              </button>
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden flex items-center">
            <button
              className="text-gray-600 focus:outline-none"
              onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-8 h-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    isMobileMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div
            className="md:hidden fixed inset-0 bg-opacity-70 bg-black z-40"
            onClick={() => setMobileMenuOpen(false)}
          ></div>
        )}

        <div className={`md:hidden fixed inset-y-0 right-0 bg-white w-64  z-50 transform ${

                    isMobileMenuOpen ? "translate-x-0" : "translate-x-full"

                  } transition-transform duration-300 ease-in-out`}>

                  <div className="flex flex-col items-start px-6 py-8 space-y-4">

                    {["home", "about", "Classes", "contactUs"].map((link) => (

                      <Link

                        key={link}

                        to={link === "home" ? "/" : `/${link.toLowerCase()}`}

                        onClick={() => handleLinkClick(link)}

                        onMouseEnter={() => setIsHovered(link)}

                        onMouseLeave={() => setIsHovered(null)}

                        className="block text-lg font-medium transition duration-200 relative navbar-link"

                        style={{

                          color: activeLink === link || isHovered === link ? linkColors[link] : "black",

                        }}

                      >
                {link.charAt(0).toUpperCase() + link.slice(1)}
                <span
                  className={`absolute -top-2 left-1/2 transform -translate-x-1/2 w-2 h-2 rounded-full transition-all duration-200 ${
                    activeLink === link || isHovered === link ? "block translate-y-[-4px]" : "hidden"
                  }`}
                  style={{ backgroundColor: linkColors[link] }}
                ></span>
              </Link>
            ))}

            <div className="mt-6">
              <button onClick={() => navigate("/enquiry")}className="px-4 py-2 bg-[#16bab1] text-white rounded-md shadow-lg">
                Enquiry
              </button>
            </div>

            <div className="mt-4">
              <Link to="/" className="block text-lg  text-[#1da0d7]">
                <IoCall className="inline-block mr-2" />
                99945 58487
              </Link>
            </div>
          </div>
        </div>

        {isModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white p-4 rounded-2xl shadow-2xl w-full max-w-4xl overflow-y-auto max-h-screen">
    <div className="flex items-center  justify-center mb-5 border-b pb-4">
  <div className="flex items-center space-x-2">
    <img src={logo1} alt="Kalam Kids Logo" className="h-30 w-40 object-contain" />
    <div className="bg-gray-600 h-10 w-0.5 "></div>

    <div>
      <h1 className="text-[#16bab1] text-lg md:text-xl font-extrabold">
         ENQUIRY FORM : {academicYear}
      </h1>
      <p className="text-gray-700 font-medium text-sm md:text-base mt-1">
        Smart start. Strong foundation.
      </p>
    </div>
  </div>
</div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <input
          type="text"
          name="studentName"
          placeholder="Student Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <select
          name="gender"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        >
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>

        {/* Date of Birth */}
        <div className="relative">
          <input
            type="date"
            name="dob"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            onChange={handleInputChange}
          />
          {formData.age !== "" && (
            <div className="absolute top-4 right-12 flex items-center text-gray-700 font-medium">
              Age: <span className="ml-2">{formData.age}</span>
            </div>
          )}
        </div>

        {/* Father Details */}
        <input
          type="text"
          name="fatherName"
          placeholder="Father Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="fatherMobile"
          placeholder="Father's Mobile Number"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="email"
          name="fatherEmail"
          placeholder="Father's Email ID"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />

        {/* Mother Details */}
        <input
          type="text"
          name="motherName"
          placeholder="Mother Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="motherMobile"
          placeholder="Mother's Mobile Number"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="email"
          name="motherEmail"
          placeholder="Mother's Email ID"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />

        {/* New Address Fields */}
        <input
          type="text"
          name="plotNo"
          placeholder="Plot No/Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="street"
          placeholder="Street"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="landmark"
          placeholder="Landmark"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />

        {/* Address */}
        <input
          type="text"
          name="area"
          placeholder="Area"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="city"
          placeholder="City"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="state"
          placeholder="State"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <select
          name="academicYear"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={formData.academicYear}
          onChange={handleInputChange}
          required
        >
          <option value="">Select Academic Year</option>
          {academicYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </form>
      
      {/* Action Buttons */}
      <div className="flex justify-end gap-4 mt-3">
        <button
          className="px-6 py-2 border text-black rounded-md"
          onClick={() => setModalOpen(false)}
        >
          Close
        </button>
       { <button
          type="submit"
          className="px-6 py-2 bg-[#16bab1] text-white rounded-md shadow-lg"
          onClick={handleSubmit}
        >
        {isSubmitting ? <Loader /> : "Submit"}
        </button>}
      </div>
    </div>
  </div>
)}

        {/* Thank You Message Dialog */}
        {showThankYou && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-80">
               <MdCheckCircle
                                  className="text-green-500 mx-auto mb-3"
                                  size={48}
                                />
              <h2 className="text-lg font-semibold text-[#16bab1] text-center">Thank You!</h2>
              <p className="text-[#16bab1] text-center mt-2">Your enquiry has been submitted successfully.</p>
              {/* <div className="flex justify-center mt-4">
                {/* <button
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  onClick={() => setShowThankYou(false)}
                >
                  Close
                </button> */}
              {/* </div> */}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;